import { Route, Routes } from "react-router-dom";

import ADLogoutPage from "../pages/Login/ADLogoutPage";
import ForgotPasswordPage from "../pages/Login/ForgotPasswordPage";
import LoginPage from "../pages/Login/LoginPage";
import PasswordPage from "../pages/Login/PasswordPage";
import PasswordResetPage from "../pages/Login/PasswordResetPage";


const LoginNavigator = () => {
  return (
    <>
      <Routes>
        <Route
          index
          element={
            <LoginPage />
          }
        />
        <Route
          path="/Password"
          element={<PasswordPage />}
        />
        <Route
          path="/ForgotPassword"
          element={<ForgotPasswordPage />}
        />
        <Route
          path="/PasswordReset"
          element={<PasswordResetPage />}
        />
        <Route
          path="/ADLogout"
          element={<ADLogoutPage />}
        />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </>
  );
};

export default LoginNavigator;
